import { formatCommasNumber } from "./format-number-with-commas";

export const getShippingPriceText = (shippingPrice: number) => {
  return shippingPrice === 0
    ? "0 (무료)"
    : `${formatCommasNumber(shippingPrice)}`;
};
